import styled from "styled-components";
import { FlexWrapper } from "../AdAssistant.styled";

export const ModalWrapper = styled.div`
  width: 100%;
  padding: 23px 40px;
  border-radius: 5px;
  background-color: rgb(239, 241, 252);

  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: 1fr;
  gap: 50px;
  align-items: start;

  max-height: 100vh;
  overflow-y: auto;
  padding-bottom: 50px;

  @media screen and (min-width: 1920px) {
    gap: 90px;
  }
`;

export const Footer = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  justify-content: flex-start;
  margin-top: 10px;
`;

export const EditionTypeOption = styled.div`
  display: flex;
  cursor: pointer;
  padding: 6px 10px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 3px;
  border: 1px solid var(--primary-dark-200);
  background-color: ${({ selected }) => (selected ? "var(--primary-dark-100)" : "transparent")};
  color: ${({ selected }) => (selected ? "var(--primary-dark-600)" : "var(--primary-blue)")};
  transition: all 0.2s ease-in-out;

  @media screen and (width < 730px) {
    span {
      display: none;
    }
  }
`;

export const EditionInputsContainer = styled(FlexWrapper)`
  display: flex;
  width: 350px;
  padding: 10px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  border-radius: 5px;
  border: 1px solid var(--primary-dark-200);
  background-color: var(--primary-dark-100);

  @media screen and (max-width: 1250px) {
    width: unset;
    max-width: 350px;
    min-width: 250px;
  }
`;

export const EditionSection = styled.section`
  display: flex;
  gap: 10px;
  flex-direction: column;
  font-size: 12px;
  font-weight: 500;
  > span {
    color: ${({ isDisabled }) => (isDisabled ? "#7A89F4" : "#121214")};
  }
`;

export const UploadButton = styled.button`
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  display: inline-flex;
  height: 30px;
  padding: 11px 17px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  transition: background 0.3s ease-in-out, color 0.3s ease-in-out, border 0.3s ease-in-out;
  background: ${({ theme }) => theme.colors.campaignCreationNavigation.saveDraftButtonBgColor};
  color: ${({ theme }) => theme.colors.campaignCreationNavigation.saveDraftButtonTextColor};
  border-radius: 4px;
  border: ${({ theme }) =>
    `1px solid ${theme.colors.campaignCreationNavigation.saveDraftButtonBorderColor}`};
  min-width: max-content;

  &:hover {
    background: ${({ theme }) =>
      theme.colors.campaignCreationNavigation.saveDraftButtonHoverBgColor};
    color: ${({ theme }) => theme.colors.campaignCreationNavigation.saveDraftButtonHoverTextColor};
    border: ${({ theme }) =>
      `1px solid ${theme.colors.campaignCreationNavigation.saveDraftButtonHoverBorderColor}`};
  }

  &:disabled {
    cursor: not-allowed;
    background: ${({ theme }) =>
      theme.colors.campaignCreationNavigation.saveDraftButtonDisabledBgColor};
    color: ${({ theme }) =>
      theme.colors.campaignCreationNavigation.saveDraftButtonDisabledTextColor};
    border: ${({ theme }) =>
      `1px solid ${theme.colors.campaignCreationNavigation.saveDraftButtonDisabledBorderColor}`};
  }

  @media screen and (min-width: 1920px) and (min-device-pixel-ratio: 2),
    screen and (min-width: 1920px) and (min-resolution: 192dpi) {
    width: 70px;
    height: 39px;
  }
`;

export const Header = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 43px;
  padding: 8px 40px;
  color: #7a89f4;
  font-size: 14px;
  background: white;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  gap: 34px;
  align-items: center;
`;

export const Title = styled.span`
  color: #7a89f4;
  font-size: 14px;
  font-weight: 600;
`;

export const PlacementsContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  color: #7a89f4;
  font-size: 14px;
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
`;

export const CloseButton = styled.button`
  display: flex;
  width: 35px;
  height: 35px;
  justify-content: center;
  align-items: center;
  gap: 22px;
  flex-shrink: 0;
  cursor: pointer;

  border-radius: 4px;
  border: 1px solid transparent;
  background: ${({ darkMode }) => (darkMode ? "#2C2D5F" : "#eff1fc")};
`;

export const StickyFooter = styled.div`
  position: sticky;
  width: 100%;
  padding: 30px 0px;
  display: flex;
  justify-content: flex-end;
  bottom: -2px;
  z-index: 10;
  background: linear-gradient(180deg, rgba(239, 241, 252, 0) 0%, #eff1fc 34.4%);
  margin-top: 0px;
`;
